// extracted by mini-css-extract-plugin
export default {"dialogTitle":"SellerLink_dialogTitle__lSSB+","icon":"SellerLink_icon__O+p56","name":"SellerLink_name__wIjAG"};